import { render, staticRenderFns } from "./ExternalLinkItem.vue?vue&type=template&id=2f49fecc&scoped=true&"
import script from "./ExternalLinkItem.vue?vue&type=script&lang=js&"
export * from "./ExternalLinkItem.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2f49fecc",
  null
  
)

export default component.exports